<template>
  <div v-loading="showFlag">
    <!--  受注製品選択画面 -->
    <t-card>
      <!-- 注文情報 -->
      <div :style="{ height: basicHeight + 'px', 'padding-top': '10px' }">
        <t-form
          :model="searchConditionForm"
          label-position="right"
          :label-width="$t('widgetSize.ORDER.SEARCH_LABEL_WIDTH')"
        >
          <t-row>
            <t-col :span="colArr.colL">&nbsp;</t-col>
            <!-- 仕入先 -->
            <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.COMMON_CONSTANT.SUPPLIER')"
                class="marginBottom"
              >
                <!-- <t-input v-model="searchConditionForm.searchSupCode" disabled>
                </t-input> -->
                <t-select
                  clearable
                  class="commonDialog"
                  v-model="searchConditionForm.searchSupCode"
                  :placeholder="$t('resource.sys.hidden')"
                >
                  <t-option
                    v-for="item in supCpyList"
                    :key="item.supCode"
                    :label="item.supCode + ':' + item.supAbbreviation"
                    :value="item.supCode"
                  >
                  </t-option>
                </t-select>
              </t-form-item>
            </t-col>
            <!-- 見積No -->
            <t-col :span="colArr.colCom">
              <t-form-item
                :label="$t('resource.COMMON_CONSTANT.ESTIMATED_NO')"
                class="marginBottom"
              >
                <t-input
                  v-model="searchConditionForm.searchQuoteNo"
                  class="commonDialog"
                  maxlength="20"
                  :clearable="true"
                >
                </t-input>
              </t-form-item>
            </t-col>

            <t-col :span="colArr.colCom" align="center">
              <!-- 検索 -->
              <t-button
                round
                type="primary"
                class="dialogButton_120_40"
                style="margin-top: 0"
                ref="searchBtn"
                @click="searchClick()"
              >
                <i class="el-icon-search"></i>
                {{ $t("resource.COMMON_CONSTANT.SEARCH") }}
              </t-button>
            </t-col>

            <t-col :span="colArr.colR">&nbsp;</t-col>
          </t-row>
        </t-form>
      </div>

      <div>
        <t-row class="marginBottom">
          <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
            >&nbsp;</t-col
          >
          <t-col
            :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_TWO'))"
          >
            <!-- テーブル -->
            <div>
              <t-table
                ref="orderProductTableData"
                :data="orderProductTableData"
                class="table_common"
                header-cell-class-name="bg-default"
                :height="detailHeight"
                highlight-current-row
                :cell-class-name="tableCellClassName"
                @row-click="handleRowClick"
                @row-dblclick="handleRowDblClick"
                border
                fit
              >
                <!-- テーブルの列 -->
                <t-table-column
                  v-for="(column, index) in columns"
                  :key="index"
                  :type="column.type"
                  :prop="column.prop"
                  :label="column.label"
                  :min-width="column.width"
                  :align="column.align"
                  :header-align="column.headerAlign"
                  :class-name="column.class"
                  :show-overflow-tooltip="column.overflowTooltip"
                  :hidden="column.hidden"
                >
                </t-table-column>
              </t-table>
            </div>
          </t-col>
          <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
            >&nbsp;</t-col
          >
        </t-row>
      </div>

      <div :style="{ height: bottomHeight + 'px' }">
        <t-row class="marginBottom">
          <div>
            <!-- <t-col
              :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_NINETEEN'))"
              >&nbsp;</t-col
            > -->

            <!-- 確定ボタン -->
            <t-col
              :span="
                parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_TWENTY_THREE'))
              "
              align="right"
            >
              <t-button
                round
                type="warning"
                class="dialogButton_confirm_120_40"
                ref="confirmBtn"
                @click="confirmClick"
              >
                <i class="el-icon-check"></i>
                {{ $t("resource.COMMON_CONSTANT.CONFIRM") }}</t-button
              >
            </t-col>

            <t-col :span="parseInt($t('widgetSize.COMMON_CONSTANT.SPAN_ONE'))"
              >&nbsp;</t-col
            >
          </div>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { t } from "@/locales";
import { getOrderableOrder } from "@/services/order";
import {
  formatDateStrToString,
  getAbleSupplierInfoList,
  getDialogContentHeight,
  getEditColWidthArr,
} from "@/utils/comFunction";
import { DIALOG_LINE_HEIGHT, STR_ONE } from "@/utils/const";
import { setColumnWidth } from "@/utils/table";
import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //検索条件
      searchConditionForm: {
        searchSupCode: "",
        searchQuoteNo: "",
      },

      //受注一覧選択情報
      orderProductTableData: [],

      //基本情報のheight
      basicHeight: DIALOG_LINE_HEIGHT,
      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT,
        DIALOG_LINE_HEIGHT,
        30
      ),
      //確定ボタンのheight
      bottomHeight: DIALOG_LINE_HEIGHT,

      //列の幅
      colArr: getEditColWidthArr(window.innerWidth, 3),

      //仕入先見積依頼のテーブルの列
      columns: [
        // 見積No
        {
          prop: "aobQuoteNo",
          label: t("resource.COMMON_CONSTANT.ESTIMATED_NO"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
        },
        {
          // 受注日
          prop: "aobAcceptDate",
          label: t("resource.ORDER.ORDERED_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // 得意先納期
        {
          prop: "aobCusDeliveryDate",
          label: t("resource.ORDER.CUSTOMER_DELIVERY_DATE"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_center",
        },
        // 得意先
        {
          prop: "aobCusCodeAbb",
          label: t("resource.COMMON_CONSTANT.CUSTOMER"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
        // 仕入先
        {
          prop: "aobSupCodeAbb",
          label: t("resource.COMMON_CONSTANT.SUPPLIER"),
          width: t("widgetSize.ORDER.TABLE_DEFAULT_COLUMN_WIDTH"),
          class: "cell_txt_left",
          overflowTooltip: true,
        },
      ],

      //現在選択されているセル
      currentCell: null,

      data: null,

      showFlag: false,

      supCpyList: [],
    };
  },
  props: {
    selectItem: {
      Type: Object,
    },
  },
  mounted() {
    this.init();

    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);

    //列幅に自動調整
    setColumnWidth(this.columns, this.orderProductTableData);
  },

  methods: {
    // ダイアログを閉じる
    close() {
      this.$emit("cancel");
    },

    //确定ボタン
    confirmClick() {
      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();

      // ADD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 end↑
      //ミスミ連携番号が空、再確認してください
      if (this.currentCell.aodMsmNoCheck === STR_ONE) {
        Modal.showWarning(
          "",
          "見積No.「" +
            this.currentCell.aobQuoteNo +
            "」の" +
            t("message.ORDER.MSM_NO_CHECK"),
          {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          }
        );
        return;
      }
      // ADD 2025/08/21 ZLL 課題_ミスミ仕入先の関連対応 start↓

      var result = "";
      if (this.currentCell) {
        result = this.currentCell;
        this.$emit("ok", result);
      } else {
        Modal.showWarning("", t("message.COMMON_MESSAGE.PLEASE_SELECT_DATA"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }
    },

    //データの変換処理
    dataProcess() {
      this.orderProductTableData.map((item) => {
        //受注日の変換
        item.aobAcceptDate = formatDateStrToString(item.aobAcceptDate);

        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 start↓
        // 納期、注番の変更(見積単位⇒製品単位に変更)
        //得意先納期の変換
        // item.aobCusDeliveryDate = formatDateStrToString(
        //   item.aobCusDeliveryDate
        // );
        if (item.aobCusDeliveryDateMin == item.aobCusDeliveryDateMax) {
          item.aobCusDeliveryDate = formatDateStrToString(
            item.aobCusDeliveryDateMin
          );
        } else {
          item.aobCusDeliveryDate =
            formatDateStrToString(item.aobCusDeliveryDateMin) +
            "～" +
            formatDateStrToString(item.aobCusDeliveryDateMax);
        }
        // UPD 2025/04/24 Wjx 課題_250328~250416顧客からの改善したい点への対応 end↑

        return item;
      });
    },

    //行データのクリック処理
    handleRowClick(row) {
      this.currentCell = row;
    },

    //行データのダブルクリック処理
    handleRowDblClick(row) {
      this.currentCell = row;
      this.confirmClick();
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT,
        DIALOG_LINE_HEIGHT,
        30
      );

      this.colArr = getEditColWidthArr(window.innerWidth, 3);
    },

    // 初期化
    init() {
      this.showFlag = true;

      //見積情報の初期化
      this.infoInit();

      //検索処理
      this.searchClick();

      //列幅に自動調整
      setColumnWidth(this.columns, this.orderProductTableData);
    },

    //情報の初期化
    infoInit() {
      this.getAbleList();
    },
    //使用可能な仕入先リストの取得
    getAbleList() {
      //仕入先リスト
      this.supCpyList = getAbleSupplierInfoList(this.selectItem, "");
    },

    // 検索
    searchClick() {
      if (!this.showFlag) {
        this.showFlag = true;
      }

      //検索条件の処理
      let searchConditionFormTemp = {
        searchSupCode: this.searchConditionForm.searchSupCode,
        searchQuoteNo: this.searchConditionForm.searchQuoteNo,
      };

      getOrderableOrder(searchConditionFormTemp)
        .then((res) => {
          this.orderProductTableData = res;

          this.dataProcess();

          setColumnWidth(this.columns, this.orderProductTableData);

          Message.showSuccess(t("message.COMMON_MESSAGE.SEARCH_SUCCESS"));
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.SEARCH_FAILURE"));
          }
        })
        .finally(() => {
          this.showFlag = false;

          // フォーカス削除
          this.$refs.searchBtn.$el.blur();
        });
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
  },
};
</script>
<style scoped>
</style>
